import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { Skeleton, useMediaQuery, useTheme } from '@mui/material';
import Header from './Header/Header';
import useAuth from '../../../hooks/authentication/useAuth';
import { FullScreenLoading } from '../../shared/FullScreenLoading';
import Footer from './Footer/Footer';

const MainFrame: React.FC<{ children?: React.ReactNode }> = () => {
    const [isLoading, setIsLoading] = useState(false);

    const auth = useAuth();
    const toggleIsLoading = useCallback(
        () => setIsLoading((isLoading) => !isLoading),
        []
    );

    const loadingMarkup = isLoading ? <FullScreenLoading /> : null;

    const loadingPageMarkup = (
        <>
            {/* For variant="text", adjust the height via font-size */}
            <Skeleton variant="text" sx={{ fontSize: '1rem' }} />

            {/* For other variants, adjust the size with `width` and `height` */}
            <Skeleton variant="circular" width={40} height={40} />
            <Skeleton variant="rectangular" width={210} height={60} />
            <Skeleton variant="rounded" width={210} height={60} />
        </>
    );

    const pageMarkup = isLoading ? loadingPageMarkup : <Outlet />;

    return (
        <>
            {!auth.isLoggedIn && <Navigate to={'/login'} replace />}
            {auth.isLoggedIn && (
                <>
                    <Header />
                    {loadingMarkup}
                    {pageMarkup}
                    <Footer />
                </>
            )}
        </>
    );
};

export default MainFrame;
